import React from "react";
import styles from "web/react/components/filter-redesign/filter-section.module.css";

interface FilterSectionProps {
    title?: string;
    divider?: boolean;
    children: React.ReactNode;
}

export function FilterSection({
    children,
    title,
    divider = true,
}: FilterSectionProps): JSX.Element {
    return (
        <div role="menu">
            <div className={styles.title}>{title}</div>
            <div>{children}</div>
            {divider ? <hr className={styles.divider} /> : null}
        </div>
    );
}
